import storyArt from 'assets/images/arts/new_gif.gif'
import storyArt1 from 'assets/images/arts/brown1.jpg'
import storyArt2 from 'assets/images/arts/8.jpg'
import storyArt3 from 'assets/images/arts/10.jpg'
import donateImg from 'assets/images/others/s.png'

const Story = () => {
    return (
        <section id="story">
            <div className="container">
                {/* the nft */}
                <div className="row story-row">
                    <div className="story-content-sec">
                        <div className="story-head">
                            <h4 data-aos="fade-down">The NFT</h4>
                        </div>
                        <p data-aos="fade-up">
                            Our Business Apes are a collection of 10,000 stored in the form of ERC-721 tokens on the Ethereum blockchain, which are minted through our Ethereum smart contract. Each individual ape is completely unique and computer-generated pieces of art. They are formed from over 160 distinctive, hand drawn features from our artist. Minting or buying one of these NFTs grants you all rights of ownership to the Business Ape. As an owner you can do anything with the ape you like, make it your phone background, sell it for profit or hold onto it to be a part of the club and enjoy the benefits!
                        </p>
                    </div>
                    <div className="story-img-sec">
                        <img data-aos="fade-up" className="story-img" src={storyArt} alt="Business Ape Club" />
                    </div>
                </div>
             
                {/* Reward */}
                <div className="row story-row">
                    <div className="story-img-sec">
                        <img data-aos="fade-up" className="story-img" src={storyArt1} alt="Business Ape Club" />
                    </div>
                    <div className="story-content-sec">
                        <div className="story-head">
                            <h4 data-aos="fade-down">The Club Rewards</h4>
                        </div>
                        <p data-aos="fade-up">
                            To ensure the success and growth of the project we are giving away over $500,000 & NFTs from our collection in prizes. Be on the look out to join the discord whitelists to be granted access to the presales. Be sure to check out our discord for more information!
                        </p>
                    </div>
                </div>
                {/* our cause */}
                <div className="row story-row">
                    <div className="story-content-sec">
                        <div className="story-head">
                            <h4 data-aos="fade-down">Our Cause</h4>
                        </div>
                        <p data-aos="fade-up">
                            To give back to the less fortunate we would like to donate $250,000 of proceeds to The Fred Hollows Foundation. The non-profit organisation aims to provide people in developing countries with quality eye care and restoring eye sight to those in need. Every NFT minted will go towards restoring eye sight in one person. For more information please visit their website. Any donations will be greatly appreciated. 
                            <a href="https://www.hollows.org/au/home" target="_blank" rel="noopener noreferrer"> https://www.hollows.org/au/home</a>
                        </p>
                    </div>
                    <div className="story-img-sec">
                        <img data-aos="fade-up" className="story-img" src={donateImg} alt="Business Ape Club" />
                    </div>
                </div>
                {/* project plan */}
                <div className="row story-row">
                    <div className="story-img-sec">
                        <img data-aos="fade-up" className="story-img" src={storyArt2} alt="Business Ape Club" />
                    </div>
                    <div className="story-content-sec">
                        <div className="story-head">
                            <h4 data-aos="fade-down">Project Plan</h4>
                        </div>
                        <p data-aos="fade-up">
                            To ensure the longevity of the project and to give back to our investors 50% of royalties will be going into the further development of the Business Ape Club such as token minting and our metaverse incursion in the future, marketing campaigns and rewards to holders. 10% of proceeds will also continue to be sent to The Fred Hollows Foundation.</p>
                    </div>
                </div>

                {/* The Executive */}
                <div className="row story-row">
                    <div className="story-content-sec">
                        <div className="story-head">
                            <h4 data-aos="fade-down">the Executives</h4>
                        </div>
                        <p data-aos="fade-up">
                            The Executive Apes are the 10 apes at the pinnacle of business, the charismatic leaders who revolutionise industries. They are those that have achieved technological advancement and have heavy influence on society who have won the respect of all other apes. The executives will be randomly minted during the sale. 1 of 10 Executive Apes will be given away as per the roadmap. 1 of 10 will be held back and auctioned for charity. The executives will be revealed closer to the release date - stay tuned.
                        </p>
                    </div>
                    <div className="story-img-sec">
                        <div className="reveald-soon-box">
                            <h3>will be revealed soon</h3>
                        <img data-aos="fade-up" 
                        className="" src={storyArt3} alt="Business Ape Club" />
                        </div>
                    </div>
                </div>
                {/* End */}
            </div>
        </section>
    )
}

export default Story
